<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import $ from "jquery";

const store = useStore();

const filters = computed(() => store.getters["actionLogs/getFilters"]);

const startDate = computed({
  get: () => filters.value.startDate,
  set: (value) => {
    store.dispatch("actionLogs/setFilters", { startDate: value });
  },
});

const endDate = computed({
  get: () => filters.value.endDate,
  set: (value) => {
    store.dispatch("actionLogs/setFilters", { endDate: value });
  },
});

function initializeDatepicker() {
  $("#datedatepickerActionLogs").daterangepicker(
    {
      startDate: moment(startDate.value),
      endDate: moment(endDate.value),
      maxDate: moment(),
      locale: {
        cancelLabel: "Clear",
        applyLabel: "Apply",
        format: "DD MMM YYYY",
      },
    },
    function (start, end) {
      startDate.value = start.format("YYYY-MM-DD");
      endDate.value = end.format("YYYY-MM-DD");
    }
  );
}

onMounted(async () => {
  initializeDatepicker();
});
</script>

<template>
  <div class="col-lg-12">
    <div class="form-group">
      <label>Date Range</label>
      <div class="row">
        <div class="col-12">
          <input
            type="text"
            placeholder="Date"
            id="datedatepickerActionLogs"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.fetch-historical-logs {
  width: 180px;
}
</style>
